module.exports = __webpack_public_path__ + "img/IE.bcdec9dd.png";